import { color, section, button } from '@settings/common';

const imageFields = () => [
  {
    name: 'image',
    label: 'Image',
    component: 'image',
  },
  {
    name: 'name',
    label: 'Name',
    component: 'text',
    description: 'Displayed at bottom-left of image (e.g. @username)',
  },
  {
    name: 'alt',
    label: 'Alt Text',
    component: 'text',
    description: 'Brief description of the image for accessibility',
  },
];

const defaultImage = {
  image: { src: '' },
  name: '',
  alt: 'Social sharing image',
};

export function Schema({ article, blog, collection }) {
  if (article || blog || collection) return null;

  return {
    label: 'Social Sharing',
    key: 'social-sharing',
    fields: [
      {
        label: 'Content Settings',
        name: 'content',
        description: 'Headings, alignment, colors',
        component: 'group',
        fields: [
          {
            name: 'superheading',
            label: 'Super Heading',
            component: 'text',
          },
          {
            name: 'superheadingColor',
            label: 'Super Heading Color',
            component: 'select',
            options: color.options,
          },
          {
            name: 'superheadingAlignDt',
            label: 'Super Heading Alignment (Desktop)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'left' },
              { label: 'Center', value: 'center' },
            ],
          },
          {
            name: 'superheadingAlignMb',
            label: 'Super Heading Alignment (Mobile)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'left' },
              { label: 'Center', value: 'center' },
            ],
          },
          {
            name: 'heading',
            label: 'Heading',
            component: 'text',
          },
          {
            name: 'headingColor',
            label: 'Heading Color',
            component: 'select',
            options: color.options,
          },
          {
            name: 'headingAlignDt',
            label: 'Heading Alignment (Desktop)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'left' },
              { label: 'Center', value: 'center' },
            ],
          },
          {
            name: 'headingAlignMb',
            label: 'Heading Alignment (Mobile)',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'left' },
              { label: 'Center', value: 'center' },
            ],
          },
        ],
        defaultValue: {
          superheading: 'COMMUNITY',
          superheadingColor: color.value.text,
          superheadingAlignDt: 'center',
          superheadingAlignMb: 'left',
          heading: 'Your BruMoments',
          headingColor: color.value.text,
          headingAlignDt: 'center',
          headingAlignMb: 'left',
        },
      },
      {
        name: 'images',
        label: 'Images (1:1 Ratio)',
        description:
          'Images display in a repeating pattern: large, two small stacked. Add as many as you like.',
        component: 'group-list',
        itemProps: {
          label: '{{item.name}}',
        },
        fields: imageFields(),
        defaultValue: [
          defaultImage,
          defaultImage,
          defaultImage,
          defaultImage,
          defaultImage,
          defaultImage,
        ],
      },
      {
        label: 'CTA Settings',
        name: 'cta',
        description: 'Call to action button',
        component: 'group',
        fields: [
          {
            name: 'link',
            label: 'Link',
            component: 'link',
          },
          {
            name: 'style',
            label: 'Link Style',
            component: 'select',
            options: button.options,
          },
        ],
        defaultValue: {
          link: {
            text: 'Join Facebook VIP',
            url: '',
          },
          style: button.value.primary,
        },
      },
      {
        ...section,
        defaultValue: {
          bgColor: color.value.background,
          color: color.value.text,
          desktop: {
            container: 'content',
            mt: 'none',
            py: 'md',
          },
          mobile: {
            container: 'container',
            mt: 'none',
            py: 'md',
          },
        },
      },
    ],
  };
}
